export default "__VITE_ASSET__7de56859__"